/*
 * Actions types
 getAssuntosRequest
 */
export enum CriacaoAssuntoTypes {
  GET_ASSUNTOS_RESQUEST = '@criacaoAssunto/GET_ASSUNTOS_RESQUEST',
  GET_ASSUNTOS_SUCCESS = '@criacaoAssunto/GET_ASSUNTOS_SUCCESS',
  GET_ASSUNTOS_FAILURE = '@criacaoAssunto/GET_ASSUNTOS_FAILURE',
  GET_ASSUNTOS_HANDLE_CHANGE_PAGE_RESQUEST = '@criacaoAssunto/GET_ASSUNTOS_HANDLE_CHANGE_PAGE_RESQUEST',
  GET_ASSUNTOS_HANDLE_CHANGE_PAGE_SUCCESS = '@criacaoAssunto/GET_ASSUNTOS_HANDLE_CHANGE_PAGE_SUCCESS',
  GET_ASSUNTOS_HANDLE_CHANGE_PAGE_FAILURE = '@criacaoAssunto/GET_ASSUNTOS_HANDLE_CHANGE_PAGE_FAILURE',
  CHANGE_STATE_ASSUNTOS_RESQUEST = '@criacaoAssunto/CHANGE_STATE_ASSUNTOS_RESQUEST',
  CHANGE_STATE_ASSUNTOS_SUCCESS = '@criacaoAssunto/CHANGE_STATE_ASSUNTOS_SUCCESS',
  CHANGE_STATE_ASSUNTOS_FAILURE = '@criacaoAssunto/CHANGE_STATE_ASSUNTOS_FAILURE',
  POST_ASSUNTOS_RESQUEST = '@criacaoAssunto/POST_ASSUNTOS_RESQUEST',
  POST_ASSUNTOS_SUCCESS = '@criacaoAssunto/POST_ASSUNTOS_SUCCESS',
  POST_ASSUNTOS_FAILURE = '@criacaoAssunto/POST_ASSUNTOS_FAILURE',
  UPDATE_ASSUNTOS_RESQUEST = '@criacaoAssunto/UPDATE_ASSUNTOS_RESQUEST',
  UPDATE_ASSUNTOS_SUCCESS = '@criacaoAssunto/UPDATE_ASSUNTOS_SUCCESS',
  UPDATE_ASSUNTOS_FAILURE = '@criacaoAssunto/UPDATE_ASSUNTOS_FAILURE',
}

/*
 * State Type
 */
export interface CriacaoAssuntoState {
  readonly data: [];
  readonly tempData: any;
  readonly loading: boolean;
  readonly error: boolean;
}
